export const getLitiumContext = (): LitiumContext => {
  if (typeof window === "undefined") {
    return {};
  }

  return window.__litium ?? {};
};

export const getLitiumRequestContext = (): LitiumRequestContext | null => {
  return getLitiumContext().requestContext ?? null;
};

export const getCurrentCulture = (fallback = "sv-SE"): string => {
  const requestCulture = getLitiumRequestContext()?.culture;

  if (requestCulture) {
    return requestCulture;
  }

  if (typeof document !== "undefined" && document.documentElement.lang) {
    return document.documentElement.lang;
  }

  return fallback;
};
